import styled from 'styled-components';

import Tag from '~/components/common/tag/styles';

import { color, media, spacing } from '~/theme';

export const IconContainer = styled.div`
    position: relative;
    top: 6px;
    margin-right: calc(${spacing.spacing5} + ${spacing.spacing1});
`;

export const StatusBannerContainer = styled.div`
    border-top: 1px solid ${color.palette.greyscale40};
    border-bottom: 1px solid ${color.palette.greyscale40};
    padding: ${spacing.spacing4} 0;
    background-color: ${color.palette.systemLimeGreen};
`;

export const StatusBannerContent = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    max-width: 22.625rem;
    padding-left: calc(${spacing.spacing6} / 2);
    padding-right: calc(${spacing.spacing6} / 2);

    @media ${media.small} {
        max-width: 48rem;
    }

    @media ${media.medium} {
        max-width: 72rem;
    }

    & ${Tag} {
        margin-right: ${spacing.spacing4};
    }
`;

export const StatusBannerText = styled.p`
    margin: 0;
`;

export default {
    StatusBannerContainer,
    StatusBannerContent,
    StatusBannerText,
};
